import React, { type ReactNode } from 'react';
import EmptyState from '@atlaskit/empty-state';
import {
	type WrappedComponentProps,
	type MessageDescriptor,
	FormattedMessage,
	injectIntl,
} from 'react-intl-next';
import errorImage from '../../../../view/empty-state/icons/error.svg';
import ContactSupport from '../contact-support';

interface BaseUnknownErrorProps {
	messages: {
		title: MessageDescriptor;
		description: MessageDescriptor;
	};
}

const BaseUnknownError = ({
	intl: { formatMessage },
	messages,
}: WrappedComponentProps & BaseUnknownErrorProps) => (
	<EmptyState
		imageUrl={errorImage}
		imageWidth={71}
		header={formatMessage(messages.title)}
		description={
			<FormattedMessage
				{...messages.description}
				values={{
					link: (chunks: ReactNode) => <ContactSupport label={chunks} />,
				}}
			/>
		}
		testId="confluence-project-pages.unknown-error"
	/>
);

export default injectIntl(BaseUnknownError);
